/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
import { Config, createRuntime, ensureTransferableError } from "@evolu/common";
import * as Effect from "effect/Effect";
import { nanoid } from "nanoid";
export const wrap = (worker) => {
    const callbacks = new Map();
    worker.onmessage = ({ data: message }) => {
        const callback = callbacks.get(message.id);
        if (callback) {
            callback(message.response);
            callbacks.delete(message.id);
        }
    };
    const proxy = new Proxy(worker, {
        get(target, name) {
            return (...argsMaybeWithCallback) => Effect.flatMap(Config, (config) => Effect.async((resume) => {
                const ports = [];
                const args = argsMaybeWithCallback.map((arg) => {
                    if (typeof arg !== "function")
                        return arg;
                    const channel = new MessageChannel();
                    channel.port1.onmessage = ({ data }) => {
                        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                        arg(...data);
                    };
                    ports.push(channel.port2);
                    return channel.port2;
                });
                // Nanoid is pretty fast. No reason to use incremented counter.
                const id = nanoid();
                callbacks.set(id, (response) => {
                    resume(Effect[response._tag](response.value));
                });
                const message = { id, name, args, config };
                target.postMessage(message, ports);
            }));
        },
    });
    return proxy;
};
/** Expose an object with functions returning Effect. */
export const expose = (object) => {
    let runtime = null;
    onmessage = ({ data: { id, name, args, config }, }) => {
        if (runtime == null)
            runtime = createRuntime(config);
        const argsMaybeWithCallback = args.map((arg) => {
            if (!(arg instanceof MessagePort))
                return arg;
            return (...args) => {
                arg.postMessage(args);
            };
        });
        runtime.runFork(object[name](...argsMaybeWithCallback).pipe(Effect.map((value) => ({ id, response: { _tag: "succeed", value } })), Effect.catchAll((value) => Effect.succeed({ id, response: { _tag: "fail", value } })), Effect.catchAllDefect((error) => Effect.succeed({
            id,
            response: { _tag: "die", value: ensureTransferableError(error) },
        })), Effect.tap((message) => postMessage(message))));
    };
};
